import React from "react";
import SuccessIcon from "../Icons/SuccessIcon";

interface LoginEmailSentCardProps {
  emailSentType: "invitation" | "password_reset" | "verification" | null;
  onBackToLogin: () => void;
}

const LoginEmailSentCard: React.FC<LoginEmailSentCardProps> = ({
  emailSentType,
  onBackToLogin,
}) => {
  return (
    <div className="w-full max-w-sm flex flex-col items-center">
      <div className="w-16 h-16 rounded-full bg-green-50 border border-green-200 flex items-center justify-center mb-6">
        <SuccessIcon className="w-8 h-8 text-green-600" />
      </div>
      <h2 className="text-2xl font-semibold text-[#1f2937] mb-4 text-center font-['Proxima_Nova']">
        {emailSentType === "invitation"
          ? "Invitation Email Sent"
          : emailSentType === "verification"
          ? "Verification Email Sent"
          : "Password Email Sent"}
      </h2>
      <p className="text-sm text-gray-500 text-center mb-6 font-['Proxima_Nova']">
        Please check your inbox and follow the instructions in the email
        to continue.
      </p>
      <button
        onClick={onBackToLogin}
        className="bg-[#4D5874] relative mt-4 flex w-full items-center justify-center rounded-[10px] h-[52px] min-h-[52px] px-4 text-base font-medium text-white transition-all duration-200 hover:bg-[#4D5874]/90 shadow-md font-['Proxima_Nova']"
      >
        Back to Login
      </button>
    </div>
  );
};

export default LoginEmailSentCard;